import { LanguageCode } from '@hazadapt-git/public-core-base'
import { Close } from '@mui/icons-material'
import {
    Dialog,
    DialogTitle,
    Typography,
    DialogContent,
    IconButton,
    DialogActions,
    Button,
    Stack,
} from '@mui/material'
import React, { FC } from 'react'

import {
    prepCheckLimitReachedModalText,
    PrepCheckLimitReachedModalTextConfig,
} from '../../i18n'
import { Markdown } from '../atoms'
import { InfoUsageDisclaimer } from './InfoUsageDisclaimer'

interface PrepCheckLimitReachedModalProps {
    open: boolean
    onClose: React.MouseEventHandler
    onSignUpClick: () => void
    lang?: LanguageCode
}

export const PrepCheckLimitReachedModal: FC<PrepCheckLimitReachedModalProps> = (
    props: PrepCheckLimitReachedModalProps
) => {
    const modalConfig: PrepCheckLimitReachedModalTextConfig | undefined =
        prepCheckLimitReachedModalText.get(props.lang ?? LanguageCode.ENGLISH)

    return modalConfig ? (
        <Dialog
            open={props.open}
            PaperProps={{ sx: { maxHeight: '80vh', padding: '0.5rem 0' } }}
        >
            <DialogTitle>🔒 {modalConfig.title}</DialogTitle>
            <DialogContent>
                <IconButton
                    onClick={props.onClose}
                    sx={{
                        position: 'absolute',
                        top: '0.5rem',
                        right: '0.5rem',
                    }}
                >
                    <Close />
                </IconButton>
                <Markdown content={modalConfig.blurbChunk1} />
                <Markdown content={modalConfig.blurbChunk2} />
                <Typography>{modalConfig.benefitsTitle}</Typography>
                {modalConfig.benefits.map((benefit, index) => (
                    <Typography key={index}>✅ {benefit}</Typography>
                ))}
                <Stack my={'1rem'}>
                    <Typography fontWeight={500}>
                        {modalConfig.privacyTitle}
                    </Typography>
                    <Typography>{modalConfig.privacyBlurb}</Typography>
                </Stack>
                <InfoUsageDisclaimer lang={props.lang} />
            </DialogContent>
            <DialogActions sx={{ margin: '0.5rem 0.5rem 0' }}>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={props.onSignUpClick}
                >
                    {modalConfig.cta}
                </Button>
            </DialogActions>
        </Dialog>
    ) : null
}
